/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/destructuring-assignment */
import { DataGrid, GridToolbar, frFR } from '@mui/x-data-grid';
import { Typography, Skeleton, Divider, Card, Box, useTheme } from '@mui/material';
import { useState, useCallback, useEffect } from 'react';
import numeral from 'numeral';
import useMounted from '../../../hooks/useMounted';
import { shiftApi } from '../../../api/shiftApi';
import { alpha } from '@mui/material/styles';
import { getTone, toneAlpha, lightVeil, greyAlpha, grey } from '../../../theme/tones';

const ShiftStatistiqueFinished = () => {
  const mounted = useMounted();
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [statsInformations, setStatsInformations] = useState([]);
  const [statsInformationsDetails, setStatsInformationsDetails] = useState([]);
  const [otherStatus, setOtherStatus] = useState([]);
  const [transformRate, setTransformRate] = useState([]);

  const getSessions = useCallback(async () => {
    try {
      const data = await shiftApi.getShiftStatsFinished(localStorage.getItem('accessToken'));

      if (mounted.current) {
        setStatsInformations(data.shift);
        setStatsInformationsDetails(data.shiftDetails);
        setOtherStatus(data.otherStatus);
        setTransformRate(data.transformRate);
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted]);

  useEffect(() => {
    getSessions();
  }, [getSessions]);

  const rows = [];
  const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

  // turnover et nombre total par statut
  const totalTurnoverByMonth = {};
  const totalNumberByMonth = {};

  months.forEach((month) => {
    // initialisation des turnovers et nombres par mois
    totalTurnoverByMonth[month] = 0;
    totalNumberByMonth[month] = 0;
  });

  statsInformations.forEach((item) => {
    const row = {
      id: item.status,
      statusFinished: item.status,
    };

    row.turnoverTotal = 0;
    row.numberTotal = 0;

    // calcul du turnover par ligne total
    let totalTurnoverByRow = 0;

    months.forEach((month) => {
      totalTurnoverByRow += parseFloat(item[`turnover${month}`]);
    });
    // parcourir months pour faire correspondre ce qui revient de bdd avec les variables dynamiques
    months.forEach((month) => {
      row[`number${month}`] = item[`number${month}`];
      row[`turnover${month}`] = item[`turnover${month}`] === null ? parseFloat(0).toFixed(2) : parseFloat(item[`turnover${month}`]).toFixed(2);
      totalTurnoverByMonth[month] += item[`turnover${month}`] === null ? 0 : item[`turnover${month}`];
      totalNumberByMonth[month] += item[`number${month}`];
      row.numberTotal += item[`number${month}`];
      row.turnoverTotal += item[`turnover${month}`];
    });
    rows.push(row);
  });

  // ajout de la ligne statistique globale
  if (statsInformations.length > 0) {
    const row = {
      id: 'sous-total',
      statusFinished: 'Sous-total',
    };

    // calcul du turnover par ligne total de la ligne statistique
    row.numberTotal = 0;
    row.turnoverTotal = 0;

    // parcourir status pour faire correspondre ce qui revient de bdd avec les variables dynamiques
    months.forEach((month) => {
      row[`number${month}`] = totalNumberByMonth[month];
      row[`turnover${month}`] = parseFloat(totalTurnoverByMonth[month]).toFixed(2);
      row.numberTotal += totalNumberByMonth[month];
      row.turnoverTotal += totalTurnoverByMonth[month];
    });
    rows.push(row);
  }

  statsInformationsDetails.forEach((item) => {
    const row = {
      id: item.status,
      statusFinished: item.status,
    };

    row.turnoverTotal = 0;
    row.numberTotal = 0;

    // calcul du turnover par ligne total
    let totalTurnoverByRow = 0;

    months.forEach((month) => {
      totalTurnoverByRow += parseFloat(item[`turnover${month}`]);
    });
    // parcourir months pour faire correspondre ce qui revient de bdd avec les variables dynamiques
    months.forEach((month) => {
      row[`number${month}`] = item[`number${month}`];
      row[`turnover${month}`] = item[`turnover${month}`] === null ? parseFloat(0).toFixed(2) : parseFloat(item[`turnover${month}`]).toFixed(2);
      totalTurnoverByMonth[month] += item[`turnover${month}`] === null ? 0 : item[`turnover${month}`];
      totalNumberByMonth[month] += item[`number${month}`];
      row.numberTotal += item[`number${month}`];
      row.turnoverTotal += item[`turnover${month}`];
    });
    rows.push(row);
  });

  if (otherStatus && otherStatus.status) {
    const row = {
      id: otherStatus.status,
      statusFinished: otherStatus.status,
    };

    row.turnoverTotal = 0;
    row.numberTotal = 0;

    // calcul du turnover par ligne total
    let totalTurnoverByRow = 0;

    months.forEach((month) => {
      totalTurnoverByRow += parseFloat(otherStatus[`turnover${month}`]);
    });
    // parcourir months pour faire correspondre ce qui revient de bdd avec les variables dynamiques
    months.forEach((month) => {
      row[`number${month}`] = otherStatus[`number${month}`];
      row[`turnover${month}`] = otherStatus[`turnover${month}`] === null ? parseFloat(0).toFixed(2) : parseFloat(otherStatus[`turnover${month}`]).toFixed(2);
      totalTurnoverByMonth[month] += otherStatus[`turnover${month}`] === null ? 0 : otherStatus[`turnover${month}`];
      totalNumberByMonth[month] += otherStatus[`number${month}`];
      row.numberTotal += otherStatus[`number${month}`];
      row.turnoverTotal += otherStatus[`turnover${month}`];
    });
    rows.push(row);
  }

  if (transformRate && transformRate.status) {
    const rowTransformRate = {
      id: transformRate.status,
      statusFinished: transformRate.status,
    };

    rowTransformRate.turnoverTotal = (transformRate.turnoverYear / transformRate.turnoverYearTotal) * 100;

    // parcourir months pour faire correspondre ce qui revient de bdd avec les variables dynamiques
    months.forEach((month) => {
      rowTransformRate[`turnover${month}`] = transformRate[`turnover${month}`] === null ? parseFloat(0).toFixed(2) : parseFloat(transformRate[`turnover${month}`]).toFixed(2);
    });
    rows.push(rowTransformRate);
  }

  const columns = [
    { field: 'statusFinished',
      headerName: 'Statut',
      width: 140,
      renderCell: (cellValues) => {
        const isTotal = cellValues.row.statusFinished === 'Sous-total' || cellValues.row.statusFinished === 'Taux transform.';
        return (
          <Typography sx={{ 
            fontWeight: isTotal ? 900 : 700, 
            fontSize: isTotal ? '0.85rem' : '0.82rem',
            color: isTotal ? 'primary.main' : 'text.primary',
            textTransform: isTotal ? 'uppercase' : 'none',
            letterSpacing: isTotal ? '0.02em' : 'none'
          }}>
            {cellValues.row.statusFinished}
          </Typography>
        );
      } }
  ];

  months.forEach((month) => {
    columns.push({
      field: `turnover${month}`,
      headerName: month,
      width: 115,
      renderCell: (cellValues) => {
        const isBold = cellValues.row.statusFinished === 'Sous-total' || cellValues.row.statusFinished === 'Taux transform.';
        const val = parseFloat(cellValues.row[`turnover${month}`]);
        const num = cellValues.row[`number${month}`];

        if (cellValues.row.statusFinished === 'Taux transform.') {
          return (
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%'
            }}>
              <Box sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: '12px',
                fontWeight: 900,
                color: 'primary.main',
                backgroundColor: theme.palette.mode === 'light' ? toneAlpha('blue', 0.08) : toneAlpha('blue', 0.15),
                border: (theme) => `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
                fontSize: '0.8rem',
                textAlign: 'center',
                minWidth: '70px'
              }}>
                {cellValues.row[`turnover${month}`]} %
              </Box>
            </Box>
          );
        }

        if (cellValues.row.statusFinished === 'Sous-total') {
          return (
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              py: 0.5
            }}>
              <Typography sx={{ fontWeight: 900, fontSize: '0.82rem', color: 'text.primary' }}>
                {numeral(val).format('0,0').replaceAll(',', ' ')} €
              </Typography>
              <Box sx={{
                mt: 0.5,
                px: 1,
                py: 0.2,
                borderRadius: '6px',
                backgroundColor: 'action.hover',
                fontSize: '0.68rem',
                color: 'text.secondary',
                fontWeight: 700
              }}>
                {num}
              </Box>
            </Box>
          );
        }

        // Normal cells
        let bg = 'transparent';
        let border = 'none';
        let textColor = 'text.primary';
        let opacity = 1;

        if (val === 0) {
          opacity = 0.4;
          textColor = 'text.secondary';
        } else if (val > 10000) {
          bg = toneAlpha('emerald', 0.08);
          border = `1px solid ${toneAlpha('emerald', 0.2)}`;
          textColor = getTone('emerald').base;
        } else if (val > 0 && val <= 1000) {
          bg = toneAlpha('rose', 0.06);
          border = `1px solid ${toneAlpha('rose', 0.15)}`;
          textColor = getTone('rose').base;
        } else {
          bg = theme.palette.mode === 'light' ? toneAlpha('indigo', 0.04) : toneAlpha('indigo', 0.1);
          border = theme.palette.mode === 'light' ? `1px solid ${toneAlpha('indigo', 0.1)}` : `1px solid ${toneAlpha('indigo', 0.2)}`;
          textColor = theme.palette.mode === 'light' ? getTone('indigo').color : getTone('indigo').light;
        }

        return (
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            opacity,
            py: 0.5
          }}>
            <Box sx={{
              px: 1.2,
              py: 0.5,
              borderRadius: '10px',
              backgroundColor: bg,
              border,
              textAlign: 'center',
              width: '95%'
            }}>
              <Typography sx={{ fontWeight: 800, fontSize: '0.78rem', color: textColor, lineHeight: 1.1 }}>
                {numeral(val).format('0,0').replaceAll(',', ' ')} €
              </Typography>
              {val > 0 && (
                <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.secondary', fontWeight: 700, display: 'block', mt: 0.2 }}>
                  {num} {num > 1 ? 'inscrits' : 'inscrit'}
                </Typography>
              )}
            </Box>
          </Box>
        );
      },
      sortComparator: (v1, v2) => v1 - v2
    });
  });

  columns.push({ field: 'turnoverTotal',
    headerName: 'Total',
    width: 140,
    renderCell: (cellValues) => {
      const val = parseFloat(cellValues.row.turnoverTotal);
      const num = cellValues.row.numberTotal;

      if (cellValues.row.statusFinished === 'Taux transform.') {
        return (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%'
          }}>
            <Box sx={{
              px: 1.5,
              py: 0.5,
              borderRadius: '12px',
              fontWeight: 900,
              color: 'primary.main',
              backgroundColor: theme.palette.mode === 'light' ? toneAlpha('blue', 0.12) : toneAlpha('blue', 0.2),
              border: (theme) => `1px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
              fontSize: '0.85rem',
              textAlign: 'center',
              minWidth: '80px'
            }}>
              {parseFloat(val).toFixed(2)} %
            </Box>
          </Box>
        );
      }

      return (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          py: 0.5
        }}>
          <Box sx={{
            px: 1.5,
            py: 0.6,
            borderRadius: '12px',
            backgroundColor: theme.palette.mode === 'light' ? toneAlpha('blue', 0.06) : toneAlpha('blue', 0.15),
            border: theme.palette.mode === 'light' ? `1px solid ${toneAlpha('blue', 0.15)}` : `1px solid ${toneAlpha('blue', 0.3)}`,
            textAlign: 'center',
            width: '95%'
          }}>
            <Typography sx={{ fontWeight: 900, fontSize: '0.82rem', color: 'primary.main', lineHeight: 1.1 }}>
              {numeral(val).format('0,0').replaceAll(',', ' ')} €
            </Typography>
            <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.secondary', fontWeight: 700, display: 'block', mt: 0.3 }}>
              {num} {num > 1 ? 'inscrits' : 'inscrit'}
            </Typography>
          </Box>
        </Box>
      );
    },
    sortComparator: (v1, v2) => v1 - v2 });

  return (
    <Card
      sx={{
        borderRadius: '24px',
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        backdropFilter: 'blur(20px)',
        boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
        overflow: 'hidden',
        p: 1
      }}
    >
      <Typography
        color="text.primary"
        variant="h6"
        sx={{ ml: 3, p: 2, fontWeight: 800, letterSpacing: '-0.01em' }}
      >
        Chiffre d&apos;affaire pour les inscrits et les inscritsD
      </Typography>
      <Divider sx={{ opacity: 0.6 }} />
      {!loading ? (
        <Box sx={{ width: '100%', p: 1.5 }}>
          <DataGrid
            localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
            initialState={{
              sorting: {
                sortModel: [{ field: 'id', sort: 'asc' }],
              },
            }}
            autoHeight
            rowHeight={70}
            rows={rows}
            columns={columns}
            pageSize={50}
            rowsPerPageOptions={[50, 100]}
            components={{ Toolbar: GridToolbar }}
            sx={{
              border: 'none',
              px: 2,
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: theme.palette.mode === 'light' ? grey(100) : greyAlpha(900, 0.3),
                borderBottom: `1px solid ${theme.palette.divider}`,
                borderRadius: '12px',
                fontWeight: 700
              },
              '& .MuiDataGrid-columnHeader': {
                color: 'text.secondary',
              },
              '& .MuiDataGrid-cell': {
                borderBottom: theme.palette.mode === 'light' ? `1px solid ${grey(100)}` : `1px solid ${lightVeil(0.03)}`,
                color: 'text.primary',
                fontSize: '0.85rem'
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: 'action.hover',
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: 'none'
              }
            }}
          />
        </Box>
      ) : (
        <Box sx={{ p: 3 }}>
          <Skeleton variant="rectangular" height={60} sx={{ borderRadius: '12px', mb: 2 }} />
          <Skeleton variant="rectangular" height={60} sx={{ borderRadius: '12px', mb: 2 }} />
          <Skeleton variant="rectangular" height={60} sx={{ borderRadius: '12px', mb: 2 }} />
          <Skeleton variant="rectangular" height={60} sx={{ borderRadius: '12px' }} />
        </Box>
      )}
    </Card>
  );
};

export default ShiftStatistiqueFinished;
